module.exports = __webpack_public_path__ + "media/images/ringrevenue/button_left_add-b619c8d018910e6a9eaec5e3986d4fc1.png";